import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import HomePage from './pages/HomePageWithCategories';
import VideoDetailPage from './pages/VideoDetailPage';
import UploadPage from './pages/UploadPage';
import CreateCategory from './pages/CreateCategory';

// 定义全局样式变量
const theme = {
  backgroundColor: '#F0F8FF', // 使用浅蓝色作为背景色，偏中性且清新
  primaryColor: '#4CAF50', // 清新的绿色，代表生机与活力
  secondaryColor: '#FFD700', // 明亮的金色（未在当前示例中使用）
  fontColor: '#333333', // 深灰色字体，确保可读性
};

// 样式化容器
const AppContainer = styled.div`
  font-family: 'Arial', sans-serif; // 简洁现代的字体
  background-color: ${theme.backgroundColor};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
`;

// 样式化导航栏
const Nav = styled.nav`
  width: 100%;
  padding: 1rem;
  background-color: ${theme.primaryColor};
  color: ${theme.fontColor};
  display: flex;
  justify-content: center;
  gap: 1rem; // 添加间距使链接之间有间隔
`;

// 样式化导航链接
const NavLink = styled(Link)`
  color: ${theme.fontColor};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

function App() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Router>
      <AppContainer>
        <Nav>
          <NavigationLinks onRefresh={() => setRefreshKey(prevKey => prevKey + 1)} />
        </Nav>
        <Routes>
          <Route path="/" element={<HomePage key={refreshKey} />} />
          <Route path="/videos/:id" element={<VideoDetailPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/create-category" element={<CreateCategory />} />
          <Route path="/movies/category/:id" element={<HomePage key={refreshKey} />} /> {/* 新增：添加 category/:id 路由 */}
        </Routes>
      </AppContainer>
    </Router>
  );
}

// 定义一个单独的组件用于处理导航链接
function NavigationLinks({ onRefresh }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isAdmin = searchParams.get('admin') === 'haleyljw';

  return (
    <>
      <NavLink to="/" onClick={onRefresh}>主页</NavLink>  
      {isAdmin && (
        <>
          <NavLink to="/upload">|上传视频</NavLink> |
          <NavLink to="/create-category">新分类</NavLink>
        </>
      )}
    </>
  );
}

export default App;